import React from 'react';
import {withRouter} from "react-router-dom"
import { BodySm, TitleXl, TitleMd, Row, Col9, Col3} from "components/elements";
import { AboutUsTopSectionContainer, TitleXlContainer, PurpleCircleContainer, BlueCircleContainer, MagentaCircleContainer, LogoContainer, FlexContainer} from './elements';
import OverlapCircles from 'components/OverlapCircles';
import ViewAllAnchor from "components/ViewAllAnchor";

function AboutUsTopWhiteSection(props) {


return(
        <AboutUsTopSectionContainer>
            <TitleXlContainer>
                <TitleXl fontWeight="900">An MIT engineer, a Harvard PhD and an internationally awarded creative walk into a room. </TitleXl>
            </TitleXlContainer>
            <FlexContainer>
            <Row>
                <Col9>               
                    <MagentaCircleContainer>   
                        <OverlapCircles borderColor="#D12FFF" dimensionsDesktop="300px" dimensionsMobile="220px" titleSize="20px" titleLineH="23px" header="false" mobileBorder="8px solid #D12FFF" copyHeader="COMMERCIAL & MEDICAL SOLUTIONS"  />
                    </MagentaCircleContainer>
                    <PurpleCircleContainer>        
                        <OverlapCircles borderColor="#6900FF" dimensionsDesktop="300px" dimensionsMobile="220px" titleSize="20px" titleLineH="23px" circlePadding="140px" header="false" mobileBorder="8px solid #6900FF" copyHeader="DATA & AI SOLUTIONS" />
                    </PurpleCircleContainer>
                    <BlueCircleContainer>
                    <OverlapCircles borderColor="#0F20FF" dimensionsDesktop="300px" dimensionsMobile="220px" titleSize="20px" titleLineH="23px" circlePadding="140px" header="false" mobileBorder="8px solid #0F20FF" copyHeader="INTEGRATED MARKETING COMMUNICATIONS"  /> 
                        <LogoContainer>
                            <img src={'/images/RC-logo.svg'} alt={'Real Chemistry logo'} className="realChemLogo" />
                        </LogoContainer>
                    </BlueCircleContainer>           
                </Col9>
                <Col3>        
                    <TitleMd>
                        Here, it’s called a Tuesday. 
                    </TitleMd>
                    <BodySm>
                        We’re built for uncommon collaboration—connecting otherwise isolated specialties around our clients’ brands. This one-of-a-kind model allows us to work in a way that better reflects how people experience healthcare.   
                    </BodySm>
                    
                    <ViewAllAnchor title={"Download our fact sheet"} href="https://assets.ctfassets.net/fzkxe4nzcokr/4rR4QtwLpHDECygDUkP9F6/f4be1a2ae9a14d086155fcc67fe3705a/RC_At-A-Glance_2022.pdf" target="_blank" borderColor="#000" borderColorHover="#fff" titleColor="#000" hoverBackground="#000" width="300px" height="44px" svgColor="#000" />
                   
                </Col3>
            </Row>
            </FlexContainer>
        </AboutUsTopSectionContainer>
    )
}

export default withRouter(AboutUsTopWhiteSection);
